import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent implements OnInit {

  @Input() current: string = '';
  @Input() crumbs: any[] = [];

  constructor() { }

  ngOnInit() {
  }

}
